"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCachePatchesFromResponse = getCachePatchesFromResponse;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const types_1 = require("./types");
function getCachePatchesFromResponse(response, objectToId) {
    const serverCachePatches = extractCachePatches(response);
    const cachePatches = serverToClientCachePatches(serverCachePatches, objectToId);
    return cachePatches;
}
function extractCachePatches(response) {
    const extractedCachePatches = [];
    for (const rootFieldKey of Object.keys(response)) {
        const cachePatches = response[rootFieldKey][types_1.cachePatchesKey];
        if (cachePatches !== undefined && Array.isArray(cachePatches)) {
            extractedCachePatches.push(...cachePatches);
        }
    }
    return extractedCachePatches;
}
function serverToClientCachePatches(serverCachePatches, objectToId) {
    return serverCachePatches.map((i) => serverToClientInstruction(i, objectToId));
}
function serverToClientInstruction(serverInstruction, objectToId) {
    switch (serverInstruction.__typename) {
        case "DeleteEntityCachePatchType": {
            const deleteEntityCachePatch = {
                type: "DeleteEntity",
                id: objectToId({
                    id: serverInstruction.deletedId,
                    __typename: serverInstruction.typename
                })
            };
            return deleteEntityCachePatch;
        }
        case "InvalidateFieldCachePatchType": {
            const invalidateCachePatch = {
                type: "InvalidateField",
                id: objectToId({
                    id: serverInstruction.id || undefined,
                    __typename: serverInstruction.typename
                }),
                fieldName: serverInstruction.fieldName
            };
            return invalidateCachePatch;
        }
        case "UpdateFieldCachePatchType": {
            const updaterFieldCachePatch = {
                type: "UpdateField",
                id: objectToId({
                    id: serverInstruction.id || undefined,
                    __typename: serverInstruction.typename
                }),
                fieldName: serverInstruction.fieldName,
                newValue: serverEntityFieldValueToEntityFieldValue(serverInstruction.entityFieldValue)
            };
            return updaterFieldCachePatch;
        }
        case "InsertElementCachePatchType": {
            const insertElementCachePatch = {
                type: "InsertElement",
                id: objectToId({
                    id: serverInstruction.id || undefined,
                    __typename: serverInstruction.typename
                }),
                fieldName: serverInstruction.fieldName,
                index: serverInstruction.index,
                newValue: serverEntityFieldValueToEntityFieldValue(serverInstruction.entityFieldValue)
            };
            return insertElementCachePatch;
        }
        case "RemoveEntityElementCachePatchType": {
            const removeEntityElement = {
                type: "RemoveEntityElement",
                id: serverInstruction.id,
                fieldName: serverInstruction.fieldName,
                entityId: serverInstruction.entityId
            };
            return removeEntityElement;
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(serverInstruction, true);
            throw new Error(`Unhandled Server CachePatch type: ${JSON.stringify(serverInstruction)}`);
        }
    }
}
function serverEntityFieldValueToEntityFieldValue(entityFieldValue) {
    if (entityFieldValue.stringValue !== null) {
        return entityFieldValue.stringValue;
    }
    if (entityFieldValue.booleanValue !== null) {
        return entityFieldValue.booleanValue;
    }
    if (entityFieldValue.intValue !== null) {
        return entityFieldValue.intValue;
    }
    if (entityFieldValue.floatValue !== null) {
        return entityFieldValue.floatValue;
    }
    if (entityFieldValue.entityFieldValueArray !== null) {
        return (entityFieldValue.entityFieldValueArray || []).map(serverEntityFieldValueToEntityFieldValue);
    }
    throw new Error(`Can't go here. Unknown field on entity fieldValue: ${JSON.stringify(entityFieldValue)}`);
}
//# sourceMappingURL=server-patches.js.map